module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-41.40b914bd.png";